import React, { ReactElement } from 'react';
import { extractSecondLevelBaseUrl } from '../../../../utils/utility';
import DaycarePackageForm from './DaycarePackageForm';

const NewDaycarePackage = ({ match: { path } }: any): ReactElement => {
  return (
    <div>
      <DaycarePackageForm path={path} backUrl={extractSecondLevelBaseUrl(path) + '/daycare-packages'}
        pageTitle={'New Day Care Package'} />
    </div>
  );
};

export default NewDaycarePackage;
